import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { buildLoginReturnFromLocation } from '../../utils/loginReturnPath.js';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (currentUser) return children;

  const invitation = new URLSearchParams(location.search).get('invitation');
  const from = buildLoginReturnFromLocation(location);
  return (
    <Navigate
      to={invitation ? `/login${location.search}` : '/login'}
      replace
      state={from ? { from } : undefined}
    />
  );
};

export default ProtectedRoute;
